const ToolbarActions = ({
  children
}) => {
  return <div className="flex items-center flex-wrap gap-1.5 lg:gap-3.5">{children}</div>;
};
export { ToolbarActions };